import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { Space } from '../../../core/access/space';
import { SpaceService } from '../../../core/services/utils/space.service';
import { AuthService } from '../../../core/services/utils/auth.service';
import { SpaceSwitcherComponent } from '../../ui/space-switcher/space-switcher.component';

/**
 * « Continuer en tant que » — la première connexion d'un compte qui ouvre
 * plusieurs espaces. Ensuite, le sélecteur du menu suffit.
 */
@Component({
  selector: 'app-choose-space',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, SpaceSwitcherComponent],
  templateUrl: './choose-space.component.html',
  styleUrl: './choose-space.component.css',
})
export class ChooseSpaceComponent {
  private readonly spaceService = inject(SpaceService);
  private readonly auth = inject(AuthService);

  readonly spaces = this.spaceService.available();
  remember = true;

  choose(space: Space): void {
    this.spaceService.switchTo(space, this.remember);
  }

  logout(): void {
    this.auth.logout();
  }
}
